  const shippingDays = async (holidays = "", holidaysJp, holidaysSaturday, holidaysSunday, interval) => {
  const globalHolidayList = await globalHolidays.holidays
  .then((res) => {
    return res
  })
  const date = new Date()
  const init = {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
    hour: date.getHours(),
    week: date.getDay(),
    interval: interval,
    holidaysJp: holidaysJp,
    holidaysSaturday: holidaysSaturday,
    holidaysSunday: holidaysSunday,
    holidayList: [],
    shippingDays: [],
    selectDate: [],
    weeks: ["日", "月", "火", "水", "木", "金", "土"],
    count: 0
  }

  //  指定休日を配列に追加
  let selectHolidays = holidays.split(',')
  if(Object.keys(selectHolidays).length > 0){
    Object.keys(selectHolidays).map((selectHoliday, index) => {
      init.holidayList.push(selectHolidays[index])
    })
  }

  const SHIPPING_DAYS = {
    defaultDays: () => {
      let nowDate = `${init.year}/${init.month}/${init.day}`,
          getDate;
      nowDate = new Date(nowDate)
      // for(let i = 0; i <= 20; i++){
      // 6日間のみ指定可能
      for(let i = 0; i <= 7; i++){
        let nonePshFlg = false
        nowDate.setDate(nowDate.getDate() + 1);

        getDate = `${nowDate.getFullYear()}/${nowDate.getMonth() + 1}/${nowDate.getDate()}`
        //祝日土日判定
        if(init.holidaysSaturday == "true" && init.holidaysSunday == "true" && init.holidaysJp == "true"){

          if(init.weeks[nowDate.getDay()] == "土"){
            nonePshFlg = true
          }
          if(init.weeks[nowDate.getDay()] == "日"){
            nonePshFlg = true
          }
          Object.keys(globalHolidayList).map((globalHoliday, index) => {
            let holidaysJpDays = new Date(Number(globalHoliday)*1000)
            let holidaysJpDate = `${holidaysJpDays.getFullYear()}/${holidaysJpDays.getMonth() + 1}/${holidaysJpDays.getDate()}`
            if(getDate == holidaysJpDate){
              nonePshFlg = true
            }
          })

          if(nonePshFlg) {
            init.holidayList.push(getDate)
          }

          // 祝日と土曜日判定
        } else if (init.holidaysSaturday == "true" && init.holidaysSunday != "true"  && init.holidaysJp == "true"){

          if(init.weeks[nowDate.getDay()] == "土"){
            nonePshFlg = true
          }
          Object.keys(globalHolidayList).map((globalHoliday, index) => {
            let holidaysJpDays = new Date(Number(globalHoliday)*1000)
            let holidaysJpDate = `${holidaysJpDays.getFullYear()}/${holidaysJpDays.getMonth() + 1}/${holidaysJpDays.getDate()}`
            if(getDate == holidaysJpDate){
              nonePshFlg = true
            }
          })

          if(nonePshFlg) {
            init.holidayList.push(getDate)
          }

          // 祝日と日曜日判定
        } else if (init.holidaysSaturday != "true" && init.holidaysSunday == "true"  && init.holidaysJp == "true"){

          if(init.weeks[nowDate.getDay()] == "日"){
            nonePshFlg = true
          }
          Object.keys(globalHolidayList).map((globalHoliday, index) => {
            let holidaysJpDays = new Date(Number(globalHoliday)*1000)
            let holidaysJpDate = `${holidaysJpDays.getFullYear()}/${holidaysJpDays.getMonth() + 1}/${holidaysJpDays.getDate()}`
            if(getDate == holidaysJpDate){
              nonePshFlg = true
            }
          })

          if(nonePshFlg) {
            init.holidayList.push(getDate)
          }
          // 祝日のみ判定
        } else if (init.holidaysSaturday != "true" && init.holidaysSunday != "true"  && init.holidaysJp == "true"){

          Object.keys(globalHolidayList).map((globalHoliday, index) => {
            let holidaysJpDays = new Date(Number(globalHoliday)*1000)
            let holidaysJpDate = `${holidaysJpDays.getFullYear()}/${holidaysJpDays.getMonth() + 1}/${holidaysJpDays.getDate()}`
            if(getDate == holidaysJpDate){
              nonePshFlg = true
            }
          })

          if(nonePshFlg) {
            init.holidayList.push(getDate)
          }
          // 土日判定
        } else if(init.holidaysSaturday == "true" && init.holidaysSunday == "true"  && init.holidaysJp != "true"){

          if(init.weeks[nowDate.getDay()] == "土"){
            nonePshFlg = true
          }
          if(init.weeks[nowDate.getDay()] == "日"){
            nonePshFlg = true
          }

          if(nonePshFlg) {
            init.holidayList.push(getDate)
          }

          // 土曜日判定
        } else if(init.holidaysSaturday == "true" && init.holidaysSunday != "true" && init.holidaysJp != "true" ) {

          if(init.weeks[nowDate.getDay()] == "土"){
            nonePshFlg = true
          }
          if(nonePshFlg) {
            init.holidayList.push(getDate)
          }

          // 日曜日判定
        } else if(init.holidaysSaturday != "true" && init.holidaysSunday == "true" && init.holidaysJp != "true" ) {
          if(init.weeks[nowDate.getDay()] == "日"){
            nonePshFlg = true
          }
          if(nonePshFlg) {
            init.holidayList.push(getDate)
          }
        }
        init.shippingDays.push(getDate)
      }

      // 配送間隔から配送指定最短を計算
      Object.keys(init.shippingDays).map((shippingDay,index) => {
        let check = false
        if(init.count < init.interval){
          for(let int=0; int < Object.keys(init.holidayList).length; int++) {
            if(init.holidayList[int] == init.shippingDays[index]){
              check = true
              break;
            }
          }
          if(!check) {
            init.count++
          }
        } else {
          init.selectDate.push(init.shippingDays[index])
        }
      })
      return init.selectDate
    }
  }

  return SHIPPING_DAYS.defaultDays()
}


const globalHolidays = {
  holidays: new Promise((resolve, rejec) => {
    const endpoint = 'https://holidays-jp.github.io/api/v1/datetime.json'
    fetch(endpoint)
    .then(res => res.json())
    .then((res) => {
      resolve(res)
    })
  })
}


const dateChecker = () => {

}
